import { createIntl, createIntlCache } from 'react-intl';
import plMessages from '@tenant/translations/pl.json';

const LanguageMap = new Map([
  [
    'pl',
    {
      locale: 'pl-PL',
      messages: plMessages,
    },
  ],
]);

const cache = createIntlCache();
const { locale, messages } = LanguageMap.get(navigator.language) || {
  locale: 'pl-PL',
  messages: plMessages,
};

export const intl = createIntl(
  {
    locale,
    messages,
    onError: (err) => {
      if (err.code === 'MISSING_TRANSLATION') {
        console.warn('Missing translation', err.message);
        return;
      }
      throw err;
    },
  },
  cache
);
